export class OrderRegisterStatuesQuantity {
  Opracowywane: number;
  Przekazane: number;
  Zamowiono: number;
  Realizacja: number;
  Wstrzymano: number;
  Zakonczono: number;
  Anulowano: number;
  Platnosci: number;
}
